import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import FaqList from '../../components/faq/FaqList';
import { renderInline } from '../../components/markdown/Markdown';
import faqContent from '../../content/pages/faq.json';
import '../products/balpressar/balpressar.css';
import '../products/komprimatorer/komprimatorer.css';
import './faq.css';

const Faq = () => {
    const { seoTitle, seoDescription, heading, intro, sections } = faqContent;

    return (
        <>
            <Helmet>
                <title>{seoTitle}</title>
                <meta name="description" content={seoDescription} />
                <link rel="canonical" href="https://cyclesolutions.se/vanliga-fragor" />
            </Helmet>

            <div className="faq-page">
                <section className="header-text">
                    <h1>{heading}</h1>
                    <p>{renderInline(intro, 'intro')}</p>

                    {sections.map((section, index) => (
                        <div className="faq-page-section" key={index}>
                            <h2>{section.heading}</h2>
                            <FaqList items={section.items} />
                        </div>
                    ))}

                    <div className="faq-page-cta">
                        <h2>Hittade du inte svaret?</h2>
                        <p>Vi hjälper dig gärna att hitta rätt balpress eller komprimator för er verksamhet.</p>
                        <Link to="/kontakt" className="faq-page-cta-button">Kontakta oss</Link>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Faq;
